import MainBadge from "@/app/[locale]/components/badge/MainBadge";
import Image from "next/image";
import React from "react";
import AgeIcon from "./AgeIcon";
import LevelIcon from "./LevelIcon";
import ArrowButton from "../buttons/ArrowButton";
import { Link } from "@/app/config/navigation";
import { CousrsListItemType } from "@/app/types";
import { useTranslations } from "next-intl";

const getCourseUrl = (course: any) => {
  return course.name 
    ? course.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    : course.id;
};

function CourseCard({ course, index }: CourseCardType) {
  const t = useTranslations("courses");

  return (
    <div className="max-w-full w-[300px] md:max-w-none h-full mx-auto md:w-[305px] lg:w-auto flex-shrink-0 bg-white drop-shadow-2xl lg:drop-shadow-3xl flex flex-col items-center text-center p-[20px] text-primary lg:px-[1.93rem] lg:py-[2.5rem] rounded-[3.5rem] lg:rounded-2xl ">
      <h3
        className="px-[0.6rem] lg:h-[5.8rem] h-[53px]  flex flex-col justify-center  text-[16px]  line-clamp-2	 lg:text-[1.87rem] font-semibold text-[#F2E30C]"
        style={{ color: course?.color }}
      >
        {course?.name}
      </h3>
      <div className="flex gap-1 min-h-[45px] justify-center flex-wrap">
        {" "}
        {course?.tags?.map((tage, index) => (
          <MainBadge
            key={index}
            className="bg-[#f2e30c54] h-min"
            style={{ background: `${course?.color}20` }}
          >
            {tage.name}
          </MainBadge>
        ))}
      </div>

      <div className="w-[50%] lg:w-[18.75rem] lg:h-[18.75rem] h-auto my-6">
        {" "}
        <Image
          width={500}
          height={500}
          alt={`${course?.name} course image`}
          src={course?.courseImgUrl || ""}
          className="w-full  h-full object-contain "
        />
      </div>
      <p className="text-[12px] line-clamp-3 lg:text-[1.12rem] lg:leading-[1.5rem] font-[500] ">
        {course.description}
      </p>
      <div className="flex gap-[2rem] text-[12px] font-[500] lg:text-[1.12rem] my-[13px] lg:mb-[2rem] ">
        <div className="flex items-center gap-3 ">
          <AgeIcon color={course?.color} />
          <span>+{course.age}</span>
        </div>
        <div className="flex items-center gap-2">
          <LevelIcon color={course?.color} />
          <span> {course.level}</span>
        </div>
      </div>
      <Link href={`/courses/${getCourseUrl(course)}`}>
        <ArrowButton
          className={`bg-[#F2E30C]`}
          style={{ background: course?.color }}
        >
          {t("view_course")}
        </ArrowButton>
      </Link>
    </div>
  );
}

export default CourseCard;
export type CourseCardType = {
  index: number;
  course: CousrsListItemType;
};
